var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8333 0.583374H11.3333C9.36242 0.583374 7.74992 2.19587 7.74992 4.16671V25.6667C7.74992 27.6375 9.36242 29.25 11.3333 29.25H32.8333C34.8041 29.25 36.4166 27.6375 36.4166 25.6667V4.16671C36.4166 2.19587 34.8041 0.583374 32.8333 0.583374ZM17.6041 14.0209C17.6041 15.508 16.4037 16.7084 14.9166 16.7084H13.1249V20.2917H10.4374V9.54171H14.9166C16.4037 9.54171 17.6041 10.7421 17.6041 12.2292V14.0209ZM26.5624 17.6042C26.5624 19.0913 25.362 20.2917 23.8749 20.2917H19.3958V9.54171H23.8749C25.362 9.54171 26.5624 10.7421 26.5624 12.2292V17.6042ZM33.7291 12.2292H31.0416V14.0209H33.7291V16.7084H31.0416V20.2917H28.3541V9.54171H33.7291V12.2292ZM13.1249 14.0209H14.9166V12.2292H13.1249V14.0209ZM4.16659 7.75004H0.583252V32.8334C0.583252 34.8042 2.19575 36.4167 4.16659 36.4167H29.2499V32.8334H4.16659V7.75004ZM22.0833 17.6042H23.8749V12.2292H22.0833V17.6042Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.9c9bd00cf595b4b2ac788a510be80803.svg";
export { ForwardRef as ReactComponent };